/*
* Pipeline Theme Custom JS
*/

if (window.theme && window.theme.custom && window.theme.custom.page_type == 'product') {
  (function() {
    const ratio = document.querySelector('.product__headline .rating__wrapper__title');
    const jdgmcontent = document.querySelector('.jdgm-header');
    if (ratio && jdgmcontent) {
      ratio.addEventListener('click', () => {
        jdgmcontent.scrollIntoView({ behavior: 'smooth', block: 'start' })
      })
    }
  })();
}


/* Fix for PageFly missing prices on live pages */
document.addEventListener('DOMContentLoaded', function() {
    function renderPageFlyPrices() {
        if (!window.__pageflyProducts) return;
        
        var priceDivs = document.querySelectorAll('div[data-pf-type="ProductPrice2"]');
        priceDivs.forEach(function(el) {
            if (el.innerHTML.trim() !== '') return;
            
            var parent = el.parentElement;
            if (!parent) return;
            var titleEl = parent.querySelector('[data-product-id]');
            if (!titleEl) titleEl = el.previousElementSibling;
            
            if (titleEl && titleEl.hasAttribute('data-product-id')) {
                var productId = titleEl.getAttribute('data-product-id');
                var pData = window.__pageflyProducts[productId];
                
                if (pData && pData.selected_or_first_available_variant) {
                    var variant = pData.selected_or_first_available_variant;
                    var price = variant.price;
                    var compare_at_price = variant.compare_at_price;
                    
                    var moneyFormat = (window.__pagefly_setting__ && window.__pagefly_setting__.moneyFormat) 
                        ? window.__pagefly_setting__.moneyFormat 
                        : "<span class=money>${{amount}}</span>";
                        
                    var formatPrice = function(cents) {
                        var amountStr = (cents / 100).toFixed(2);
                        // Some Shopify formats use {{amount_no_decimals}}
                        var str = moneyFormat.replace(/\{\{amount\}\}/g, amountStr)
                                             .replace(/\{\{amount_with_comma_separator\}\}/g, amountStr);
                        return str;
                    };
                    
                    var html = '';
                    if (compare_at_price > price) {
                        html += '<s style="font-size:0.85em; opacity:0.6; margin-right:6px;">' + formatPrice(compare_at_price) + '</s>';
                    }
                    html += '<span style="font-weight:600;">' + formatPrice(price) + '</span>';
                    
                    el.innerHTML = html;
                }
            }
        });
    }
    
    renderPageFlyPrices();
    setTimeout(renderPageFlyPrices, 1000);
    setTimeout(renderPageFlyPrices, 2500);
});

/* Account Button handler & Klaviyo Customer Hub Interception Fix */
(function() {
    function getAccountUrl() {
        var root = (window.theme && window.theme.routes && window.theme.routes.root_url) ? window.theme.routes.root_url : '/';
        if (root.charAt(root.length - 1) !== '/') {
            root += '/';
        }
        return root + 'account';
    }

    function protectAccountLinks() {
        var accountLinks = document.querySelectorAll('a[href*="account"], [data-mobile-account-link], .header__desktop__button a, .drawer__account, a[href="#k-hub"]');
        accountLinks.forEach(function(link) {
            var href = link.getAttribute('href') || '';
            if (href.indexOf('account') !== -1 || link.matches('[data-mobile-account-link], .drawer__account') || link.closest('.header__desktop__button')) {
                link.setAttribute('data-k-hub-ignore', 'true');
                if (href === '#k-hub') {
                    link.setAttribute('href', getAccountUrl());
                }
            }
        });
    }

    document.addEventListener('DOMContentLoaded', protectAccountLinks);
    window.addEventListener('load', protectAccountLinks);

    function isMobile() {
        return window.innerWidth <= 768 || (window.matchMedia && window.matchMedia('(max-width: 768px)').matches);
    }

    var spinnerTimeout;

    function getLoadingSpinner() {
        var overlay = document.getElementById('site-loading-spinner-overlay');
        if (!overlay) {
            if (!document.getElementById('site-loading-spinner-style')) {
                var style = document.createElement('style');
                style.id = 'site-loading-spinner-style';
                style.textContent = '@keyframes siteSpin { 0% { transform: rotate(0deg); } 100% { transform: rotate(360deg); } }';
                document.head.appendChild(style);
            }

            overlay = document.createElement('div');
            overlay.id = 'site-loading-spinner-overlay';
            overlay.style.cssText = 'position:fixed;top:0;left:0;width:100vw;height:100vh;z-index:9999999;display:flex;align-items:center;justify-content:center;pointer-events:none;background:transparent;opacity:0;transition:opacity 0.2s ease;';

            // White 12-petal chrysanthemum spinner (iOS activity indicator) with transparent background
            var spinnerWrapper = document.createElement('div');
            spinnerWrapper.style.cssText = 'width:36px;height:36px;display:flex;align-items:center;justify-content:center;animation:siteSpin 0.9s steps(12, end) infinite;transform-origin:center center;filter:drop-shadow(0 1px 3px rgba(0,0,0,0.45)) drop-shadow(0 0 1px rgba(0,0,0,0.25));';
            spinnerWrapper.innerHTML = '<svg width="36" height="36" viewBox="0 0 36 36" style="display:block;pointer-events:none;">' +
                '<rect x="16.6" y="3.5" width="2.8" height="7.5" rx="1.4" fill="#ffffff" opacity="1"/>' +
                '<rect x="16.6" y="3.5" width="2.8" height="7.5" rx="1.4" fill="#ffffff" opacity="0.91" transform="rotate(30 18 18)"/>' +
                '<rect x="16.6" y="3.5" width="2.8" height="7.5" rx="1.4" fill="#ffffff" opacity="0.82" transform="rotate(60 18 18)"/>' +
                '<rect x="16.6" y="3.5" width="2.8" height="7.5" rx="1.4" fill="#ffffff" opacity="0.73" transform="rotate(90 18 18)"/>' +
                '<rect x="16.6" y="3.5" width="2.8" height="7.5" rx="1.4" fill="#ffffff" opacity="0.64" transform="rotate(120 18 18)"/>' +
                '<rect x="16.6" y="3.5" width="2.8" height="7.5" rx="1.4" fill="#ffffff" opacity="0.55" transform="rotate(150 18 18)"/>' +
                '<rect x="16.6" y="3.5" width="2.8" height="7.5" rx="1.4" fill="#ffffff" opacity="0.46" transform="rotate(180 18 18)"/>' +
                '<rect x="16.6" y="3.5" width="2.8" height="7.5" rx="1.4" fill="#ffffff" opacity="0.37" transform="rotate(210 18 18)"/>' +
                '<rect x="16.6" y="3.5" width="2.8" height="7.5" rx="1.4" fill="#ffffff" opacity="0.28" transform="rotate(240 18 18)"/>' +
                '<rect x="16.6" y="3.5" width="2.8" height="7.5" rx="1.4" fill="#ffffff" opacity="0.20" transform="rotate(270 18 18)"/>' +
                '<rect x="16.6" y="3.5" width="2.8" height="7.5" rx="1.4" fill="#ffffff" opacity="0.14" transform="rotate(300 18 18)"/>' +
                '<rect x="16.6" y="3.5" width="2.8" height="7.5" rx="1.4" fill="#ffffff" opacity="0.08" transform="rotate(330 18 18)"/>' +
                '</svg>';

            overlay.appendChild(spinnerWrapper);
            document.body.appendChild(overlay);
        }
        return overlay;
    }

    function showLoadingSpinner() {
        if (!isMobile()) return;
        var overlay = getLoadingSpinner();
        requestAnimationFrame(function() {
            overlay.style.opacity = '1';
        });
        clearTimeout(spinnerTimeout);
        spinnerTimeout = setTimeout(hideLoadingSpinner, 6000);
    }

    function hideLoadingSpinner() {
        clearTimeout(spinnerTimeout);
        var overlay = document.getElementById('site-loading-spinner-overlay');
        if (overlay) {
            overlay.style.opacity = '0';
            setTimeout(function() {
                if (overlay && overlay.parentNode) {
                    overlay.parentNode.removeChild(overlay);
                }
            }, 250);
        }
    }

    window.addEventListener('pageshow', hideLoadingSpinner);

    function handleAccountClick(e) {
        var mobileBtn = e.target.closest('[data-mobile-account-link], .header__mobile__button--account');
        var desktopBtn = e.target.closest('.header__desktop__button a, a[href="#k-hub"], a.drawer__account');

        if (!mobileBtn && !desktopBtn) return;

        // Only display the loading circle on mobile
        if (isMobile() && (mobileBtn || e.target.closest('.drawer__account'))) {
            showLoadingSpinner();
        }

        var targetLink = mobileBtn || desktopBtn;
        var href = targetLink.getAttribute('href') || '';

        // If Shopify New Customer Accounts modal API is available, invoke it
        if (window.Shopify && window.Shopify.CustomerAccounts && typeof window.Shopify.CustomerAccounts.openLoginModal === 'function') {
            e.preventDefault();
            e.stopPropagation();
            window.Shopify.CustomerAccounts.openLoginModal();
            hideLoadingSpinner();
            return;
        }

        // Explicitly navigate so browser never gets stuck
        var dest = (href && href !== '#' && href !== '#k-hub') ? href : getAccountUrl();
        e.preventDefault();
        e.stopPropagation();
        window.location.href = dest;
    }

    document.addEventListener('click', handleAccountClick, true);
    document.addEventListener('pointerdown', function(e) {
        if (!isMobile()) return;
        if (e.target.closest('[data-mobile-account-link], .header__mobile__button--account, .drawer__account')) {
            showLoadingSpinner();
        }
    }, true);
})();


/* Dynamic SKU update when variant changes */
document.addEventListener('change', function(e) {
  if (e.target.matches('input[name^="options["], select[name^="options["]')) {
    setTimeout(function() {
      var skuJsonEl = document.querySelector('[data-product-variants-sku-json]');
      var skuValEl = document.querySelector('[data-sku-value]');
      if (!skuJsonEl || !skuValEl) return;
      try {
        var skuMap = JSON.parse(skuJsonEl.textContent);
        var form = e.target.closest('form') || document.querySelector('form[action*="/cart/add"]');
        var idInput = form ? form.querySelector('input[name="id"]') : document.querySelector('input[name="id"]');
        if (idInput && idInput.value && skuMap[idInput.value]) {
          skuValEl.textContent = skuMap[idInput.value];
        }
      } catch (err) {}
    }, 50);
  }
});


/* Product Grid Card: Color Swatch to Variant Image Switcher */
(function() {
  function handleSwatchClick(e) {
    var swatchDot = e.target.closest('.product__grid__swatch-circle');
    if (!swatchDot) return;

    e.preventDefault();
    e.stopPropagation();

    var card = swatchDot.closest('product-grid-item, .product-grid-item, [data-item]');
    if (!card) return;

    var variantId = swatchDot.getAttribute('data-variant-id');
    var productId = swatchDot.getAttribute('data-product-id');
    var newSrc = swatchDot.getAttribute('data-image-src');
    var newSrcset = swatchDot.getAttribute('data-image-srcset');
    var newUrl = swatchDot.getAttribute('data-variant-url');
    var newPrice = swatchDot.getAttribute('data-price');
    var newComparePrice = swatchDot.getAttribute('data-compare-at');

    // 1. If card has multiple <product-grid-item-variant> (e.g. siblings), switch visibility & unpack template
    var variantContainers = card.querySelectorAll('product-grid-item-variant');
    var matchedVariantContainer = false;
    if (variantContainers.length > 1) {
      variantContainers.forEach(function(vc) {
        var vcVariantId = vc.getAttribute('data-grid-item-variant');
        var vcProductId = vc.getAttribute('data-grid-item');
        if ((variantId && vcVariantId === variantId) || (productId && vcProductId === productId)) {
          vc.removeAttribute('hidden');
          // Unpack lazy template if any inside matched container so image shows immediately
          vc.querySelectorAll('template').forEach(function(tmpl) {
            tmpl.replaceWith(tmpl.content);
          });
          vc.querySelectorAll('product-grid-item-image').forEach(function(el) {
            el.setAttribute('loading', 'eager');
          });
          if (newSrc) {
            var activeImgBox = vc.querySelector('.product-grid-item__images') || vc;
            activeImgBox.querySelectorAll('source').forEach(function(s) {
              s.srcset = newSrcset || newSrc;
            });
            activeImgBox.querySelectorAll('img').forEach(function(img) {
              img.src = newSrc;
              if (newSrcset) {
                img.srcset = newSrcset;
              }
            });
          }
          matchedVariantContainer = true;
        } else {
          vc.setAttribute('hidden', '');
        }
      });
    }

    // 2. If single variant container or standard product, update image and picture sources
    if (!matchedVariantContainer && newSrc) {
      var imgBox = card.querySelector('.product-grid-item__images') || card;
      // Unpack template if main image was lazy-wrapped
      imgBox.querySelectorAll('template').forEach(function(tmpl) {
        tmpl.replaceWith(tmpl.content);
      });
      // Update <picture> <source> tags on mobile
      imgBox.querySelectorAll('source').forEach(function(s) {
        s.srcset = newSrcset || newSrc;
      });
      // Update <img> tags
      imgBox.querySelectorAll('img').forEach(function(img) {
        img.src = newSrc;
        if (newSrcset) {
          img.srcset = newSrcset;
        }
      });
    }

    // 3. Update links on the card so clicking leads to selected color variant
    if (newUrl) {
      card.querySelectorAll('a[data-grid-link]').forEach(function(link) {
        link.setAttribute('href', newUrl);
      });
    }

    // 4. Update price display if variant price differs
    if (newPrice) {
      var priceEl = card.querySelector('.product__grid__price .price');
      if (priceEl) {
        priceEl.textContent = newPrice;
      }
      var pricePair = card.querySelector('.product__grid__price .lm-price-pair');
      var compareEl = card.querySelector('.product__grid__price .compare-at');
      if (newComparePrice) {
        if (!compareEl && pricePair) {
          compareEl = document.createElement('s');
          compareEl.className = 'compare-at';
          pricePair.appendChild(compareEl);
        }
        if (compareEl) {
          compareEl.textContent = newComparePrice;
          compareEl.hidden = false;
          compareEl.style.display = '';
        }
      } else if (compareEl) {
        compareEl.remove();
      }
      if (priceEl) priceEl.classList.toggle('on-sale', Boolean(newComparePrice));
      if (pricePair) pricePair.classList.toggle('lm-price-pair--sale', Boolean(newComparePrice));
    }

    // 5. Update active state on swatch dots
    var swatchList = swatchDot.closest('.product__grid__swatch-list');
    if (swatchList) {
      swatchList.querySelectorAll('.product__grid__swatch-circle').forEach(function(c) {
        c.classList.remove('is-active');
      });
      swatchDot.classList.add('is-active');
    }
  }

  // Preload swatch images automatically in background so switching is instant
  function preloadSwatches() {
    document.querySelectorAll('.product__grid__swatch-circle[data-image-src]').forEach(function(dot) {
      var src = dot.getAttribute('data-image-src');
      if (src) {
        var img = new Image();
        img.src = src;
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      setTimeout(preloadSwatches, 500);
    });
  } else {
    setTimeout(preloadSwatches, 500);
  }

  document.addEventListener('touchstart', function(e) {
    var dot = e.target.closest('.product__grid__swatch-circle');
    if (dot) {
      var src = dot.getAttribute('data-image-src');
      if (src) {
        var img = new Image();
        img.src = src;
      }
    }
  }, { passive: true });

  document.addEventListener('click', handleSwatchClick, true);
})();
